import React from 'react';
const NoDataFound = () => {
  return (
    <>
      <div className="text-center mb-3 mt-12">
        <img src="/img/no-data-img.png" className="inline-block" alt="" />
      </div>
      <div className="text-brandBlue dark:text-brandBlue">
        <h5 className="font-semibold mt-6 text-center mb-2">No Data Found</h5>
      </div>
    </>
  );
};
export default NoDataFound;
